// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"410e3fba","977":"80c65017"}[chunkId] + ".chunk.js";
};